import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "list-parent" }
const _hoisted_2 = { class: "search-place" }
const _hoisted_3 = { class: "command-panel" }
const _hoisted_4 = { class: "labels-place" }
const _hoisted_5 = { class: "total-label" }
const _hoisted_6 = {
  key: 0,
  class: "selected-label"
}
const _hoisted_7 = {
  key: 0,
  class: "quick-filters-place"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Revoke ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Start new assessment ")
const _hoisted_10 = { class: "table-parent" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Revoke ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Start new assessment ")
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "el-icon-more" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("View subject details ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Edit subject ")
const _hoisted_16 = { class: "paging-place" }
const _hoisted_17 = { class: "paging-label" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Showing ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" from ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" data ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_CancelIcon = _resolveComponent("CancelIcon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_PlayCircleIcon = _resolveComponent("PlayCircleIcon")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_TableHeaderComponent = _resolveComponent("TableHeaderComponent")
  const _component_router_link = _resolveComponent("router-link")
  const _component_InfoIcon = _resolveComponent("InfoIcon")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_SearchInput, {
        modelValue: _ctx.state.search,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.search = $event)),
        "debounce-time": 500,
        onDebounceInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchChanged()))
      }, null, 8, ["modelValue"]),
      (_ctx.forbidForRole(_ctx.UserRole.Analyst))
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addSubject()))
          }, " + Add Subject "))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, "Total: " + _toDisplayString(_ctx.state.paging.total), 1),
        (_ctx.list.selected.length)
          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.list.selected.length) + " selected ", 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.forbidForRole(_ctx.UserRole.Analyst))
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_el_button, {
              class: "edit-button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.revoke())),
              disabled: _ctx.revokeDisabled
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CancelIcon),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              class: "edit-button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.startNewAssessment())),
              disabled: _ctx.startNewAssessmentDisabled
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PlayCircleIcon),
                _hoisted_9
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_10, [
      _withDirectives(_createVNode(_component_el_table, {
        class: "list-table",
        ref: "multipleTable",
        data: _ctx.list.data,
        style: {"width":"100%"},
        "header-row-class-name": "header-row",
        stripe: true,
        "select-on-indeterminate": false,
        "empty-text": "Nothing is found. Please change your search parameters",
        onSelectionChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectionChange($event)))
      }, {
        default: _withCtx(() => [
          (_ctx.forbidForRole(_ctx.UserRole.Analyst))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "selection",
                width: "55",
                fixed: ""
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: "Name",
            width: "150",
            fixed: ""
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Subject ID',
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.subject_id),
                onChangeSorting: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.subject_id, $event)))
              }, null, 8, ["sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createVNode("a", {
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.viewSubject(scope.row)), ["prevent"])
              }, _toDisplayString(scope.row[_ctx.fieldNames.subject_id]), 9, ["onClick"])
            ]),
            _: 1
          }),
          (_ctx.hasRole(_ctx.UserRole.SystemAdmin, _ctx.UserRole.Analyst))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                property: "site_name",
                label: "Site",
                width: "240"
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_TableHeaderComponent, {
                    header: 'Site',
                    filterable: true,
                    filterData: _ctx.state.filtersData.sites
                  }, null, 8, ["filterData"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: "Sex",
            width: "120"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Sex',
                filterable: true,
                filterData: _ctx.state.filtersData.sex_type,
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.sex_type),
                onChangeSorting: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.sex_type, $event)))
              }, null, 8, ["filterData", "sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.formatSex(scope.row[_ctx.fieldNames.sex_type])), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            property: _ctx.fieldNames.year_of_birth,
            label: "Year of birth",
            "min-width": "130"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Year of birth',
                rangeData: _ctx.state.filtersData.year_of_birth,
                sortable: true,
                filterable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.year_of_birth),
                onChangeSorting: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.year_of_birth, $event)))
              }, null, 8, ["rangeData", "sortingValue"])
            ]),
            _: 1
          }, 8, ["property"]),
          _createVNode(_component_el_table_column, {
            label: "HiPAL Pro",
            width: "100"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'HiPAL Pro',
                sortable: false
              })
            ]),
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.lastAssessments[scope.$index]?.assessments_amount), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            property: _ctx.fieldNames.last_assessment_date,
            label: "Email",
            "min-width": "150"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, { header: 'Last assessment date' })
            ]),
            default: _withCtx((scope) => [
              _createVNode(_component_router_link, {
                to: {
                name: 'View HiPAL Pro',
                params: {
                  id: scope.row.id || '',
                  siteId: scope.row.site_id || '',
                  assessmentId:
                    _ctx.getLastAssessment(scope.row)?.last_assessment_id || '',
                },
              }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(
                  _ctx.lastAssessments[scope.$index]?.last_assessment_timestamp
                )), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }, 8, ["property"]),
          _createVNode(_component_el_table_column, {
            label: "Code",
            width: "140"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Code',
                sortable: false
              })
            ]),
            default: _withCtx((scope) => [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.lastAssessments[scope.$index]?.invitation_code_status) + " ", 1),
                (
                  _ctx.lastAssessments[scope.$index]?.invitation_code_status ===
                    _ctx.CodeStatus.Generated
                )
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      class: "item",
                      effect: "light",
                      content: 
                    _ctx.lastAssessments[scope.$index]?.invitation_code_value
                  ,
                      placement: "right",
                      disabled: !_ctx.forbidForRole(_ctx.UserRole.Analyst)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InfoIcon)
                      ]),
                      _: 2
                    }, 1032, ["content", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (!_ctx.hasRole(_ctx.UserRole.Analyst))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                "min-width": "140"
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_TableHeaderComponent, {
                    header: '',
                    sortable: false
                  })
                ]),
                default: _withCtx((scope) => [
                  (
                _ctx.lastAssessments[scope.$index]?.invitation_code_status ===
                  _ctx.CodeStatus.Generated ||
                  _ctx.lastAssessments[scope.$index]?.invitation_code_status ===
                    _ctx.CodeStatus.Entered
              )
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "edit-button",
                        onClick: ($event: any) => (_ctx.revoke(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CancelIcon),
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        class: "edit-button",
                        onClick: ($event: any) => (_ctx.startNewAssessment(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PlayCircleIcon),
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            "class-name": "actions-cell",
            label: "Actions",
            fixed: "right",
            width: "83"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_dropdown, {
                type: "primary",
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        onClick: ($event: any) => (_ctx.viewSubject(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (_ctx.forbidForRole(_ctx.UserRole.Analyst))
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 0,
                            onClick: ($event: any) => (_ctx.editSubject(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, null, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.state.isLoading]
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode("span", null, _toDisplayString(_ctx.list.data.length), 1),
          _hoisted_19,
          _createVNode("span", null, _toDisplayString(_ctx.state.paging.total), 1),
          _hoisted_20
        ]),
        (_ctx.state.paging.total > _ctx.state.paging.pageSize)
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              class: "table-paging",
              layout: "prev, pager, next",
              "current-page": _ctx.state.paging.page,
              "page-size": _ctx.state.paging.pageSize,
              "pager-count": 5,
              total: _ctx.state.paging.total,
              onCurrentChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pageChange($event)))
            }, null, 8, ["current-page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}